export const workingInSpace1 = [
  {
    id: 1,
    uniqueId: 'working_in_space_1',
    title: 'מטבח ואזור ישיבה רחב',
    content: `**למשקיענים שאוהבים להביא אוכל מהבית,** 
    **המטבח מאובזר במקררים מלאי כל טוב,** מצנם של בתי מלון, מיקרוגלים, מכונת קרח, מכונת סודה וכל מה שתצטרכו לחימום האוכל וגם לשדרוג הארוחה עם התוספות הנדרשות. \n
    כיוון שגם הסביבה חשובה לנו השקענו בכלים רב-פעמיים ומדיח כלים לשימושכם.
     בזמן שהכלים נשטפים, תוכלו לשבת למנוחה קלה באזור הישיבה המרווח. בין אם אתם אנשים של שולחנות עגולים או כיסאות בר, מבטיחים שתמצאו שם את ה-Match שלכם.`,
  },
  {
    id: 2,
    uniqueId: 'working_in_space_2',
    title: 'מתחם האוכל בזמינות מלאה!',
    content: `במתחם תמצאו שפע של חומרי גלם להרכבת ארוחה קלה, או לשדרוג ארוחה קיימת שעשתה קאמבק מהסופ"ש. עם מיטב הירקות והפירות הטריים, לחמים שונים, מגוון גבינות, יוגורטים ומוצרי חלב. **במקרר הבריאות שלנו, פרוסים שפע של רכיבים להרכבת סלט איכותי** - מגוון קטניות ועדשים, סוגים שונים של חסות ועלים, תוספות קראנצ'יות ומבחר רטבים. וכמובן, אפשרויות למוצרים שטבעוניים אוהבים, מוצרים ללא גלוטן, וכן התאמות לכל שומרי הכשרות.`,
  },
  {
    id: 3,
    uniqueId: 'working_in_space_3',
    title: 'ספרייה',
    content: `האזור השקט, כי כולנו צריכים כזה. כאן מומלץ לבקר כשאתם צריכים אוורור מהשגרה, מחפשים קצת השראה, או אולי סתם בא לכם להביס את הקולגה בשחמט. **הספרייה מצוידת במגוון ספרי פנאי, ספרים מקצועיים ואפילו ספרי ילדים.** ולתחרותיים שבינינו, גם במגוון משחקי קופסה- לא עצרנו רק בשחמט.`,
  },
  {
    id: 4,
    uniqueId: 'working_in_space_4',
    title: 'חדר Code:Coda',
    content: `זה לא רק חדר, זאת אג'נדה! **תוכנית Code:Coda של NICE היא תכנית הכשרה ייחודית לנערות בגיל חטיבת הביניים, ללא אוריינטציה טכנולוגית, שנועדה לחשוף אותן לעולם פיתוח התוכנה.**
     באמצעות חשיפה לטכנולוגיה ויצירת חוויה חיובית, לעודד אותן לבחור בהמשך במגמות טכנולוגיות בתיכון, בתקווה שבבגרותן הן תמשכנה לתפקידים טכנולוגיים בצבא ובעולם העבודה.\n
     **במסגרת התוכנית הדו-שנתית, מגיעות בכל שבוע 250 נערות לכיתות מחשבים שעיצבנו עבורן.** צוות המדריכות המקצועי,
       נותן להן ללמוד ולהתנסות בטכנולוגיה, תכנות ובכתיבת קוד. את ההשראה שלהן הן מקבלות מעשרות נשים טכנולוגיות מדהימות, עובדות NICE, 
       שהתנדבו לקחת חלק כמנטוריות וללוות את הנערות.\n
        המטרה שלנו, היא להרחיב את מעגל הנשים בעולם הטכנולוגי, ולצמצם את הפער בין גברים לנשים בהייטק.\n
        **Code:Coda הינה תוכנית ייחודית שקיבלה את אישור משרד החינוך ויוצאת לפועל בשיתוף פעולה רב מגזרי** 
    (שיתוף פעולה של הרשות המקומית, בתי הספר והמרכז לחינוך סייבר). היא נערכת בשעות הבוקר כחלק מפעילות בית הספר. הצלחת התוכנית היא כה גדולה,
     ורבות מבין בוגרות התוכנית ממשיכות במגמה טכנולוגית בתיכון.\n
    אתן נשים בתפקידים טכנולוגיים? רוצות לקחת חלק בעיצוב העתיד? עקבו אחרי פרסומים והודעות בנושא גיוס מנטוריות לפרויקט.`,
  },
  {
    id: 5,
    uniqueId: 'working_in_space_5',
    title: 'חדר פוקוס',
    content: `לפעמים כל מה שאתם צריכים זה לשבת לבד בחושך (בקטע מרגיע), ללא הפרעות. לנוח ולחדד את המחשבה כדי לפתח את הרעיונות המנצחים שלכם. כנסו לפוקוס!`,
  },
]

export const workingInSpace2 = [
  {
    id: 6,
    uniqueId: 'working_in_space_6',
    title: 'הגג שלנו',
    content: `בגג תוכלו להנות מבריכת נוי, מוזיקה נעימה, פינות זולה, שולחנות פיקניק, ואפילו ערוגות עם צמחי תבלין שתוכלו לקטוף ולהוסיף לסלט או לתה. `,
  },
  {
    id: 7,
    uniqueId: 'working_in_space_7',
    title: 'בית קפה',
    content: `
    **קפה של בוקר? תה של צהרים? בריסטה מקצועי מגיש משקאות חמים וקרים, בשעות הבוקר תוכלו לצרף לזה גם מאפה היישר מהתנור.**\n
       לאורך כל היום נסחטים במקום מיצי פירות טריים,
        ואם זה נשמע יותר מדי בריא - יש גלידה אמריקאית עם תוספות וגם מקרר מלא בארטיקים... בכל עונה בית הקפה מתהדר בספיישל עונתי מיוחד ומפתיע... בואו לבדוק מה יש עכשיו
      פתוח בימים א'-ד' 8:00-17:00
    `,
  },
  {
    id: 8,
    uniqueId: 'working_in_space_8',
    title: 'חדר מוזיקה',
    content: `
      חדר המוזיקה שלנו כולל ציוד מתקדם וניתן ליהנות בו מכלי נגינה שונים ברמה הכי גבוהה שיש: \n
      **גיטרה בס, גיטרה חשמלית, גיטרה אקוסטית, תופים, אורגן וכמובן מגברי קול מעולים ומיקרופונים לשירה.** 
      יש ב-NICE אפילו להקה!\n
      את המפתח לחדר המוסיקה ניתן לקחת מהקבלה בקומה 0 ולהחזירו בתום השימוש.\n
      שיעורי נגינה פרטיים: חדר המוסיקה קוסם לכם אבל מעולם לא ניגנתם? לא מאוחר מדי! אנו מציעים לעובדי החברה שיעורי נגינה עם טונליין בחדר המוסיקה שבמשרד.
      [לפרטים נוספים והרשמה](https://www.tone-line.com/nice).\n
      אתם מוזמנים לנגן, אנחנו בעד שתהנו. רק תעשו לעצמכם ולחברים טובה, ושמרו על כלי הנגינה תקינים ושמישים.
    `,
  },
  {
    id: 9,
    uniqueId: 'working_in_space_9',
    title: 'שירותי כביסה',
    content: `
      שירותי כביסה, איסוף כביסה והחזרתה ממשרדי החברה ע"י מכבסת הכפר, האיסוף בחדר המיועד ליד דלפק הקבלה בלובי.\n
      פרטים נוספים כאן [שירותי כביסה](https://niceonline.sharepoint.com/sites/NWBWork/SiteAssets/SitePages/IL-Meet-The-Team/%D7%9E%D7%97%D7%99%D7%A8%D7%95%D7%9F-%D7%9B%D7%91%D7%99%D7%A1%D7%94-2023.jpg?web=1)
     
      [למחירון שירותי כביסה](https://niceonline.sharepoint.com/sites/NWBWork/SitePages/IL-Soft-Services-Other-Services.aspx)
    `,
  },
]

export const workingInSpace3 = [
  {
    id: 10,
    uniqueId: 'working_in_space_10',
    title: 'עמדות עבודה וחדרי ישיבות',
    content: `רוצים לעשות פגישת עבודה ולהרגיש ב- MoMA?  לגמרי אפשרי! **כל קומה אצלנו היא מיוחדת ומוקדשת לנושא**
    **    אחר – אומנות, דמויות מתוכניות טלוויזיה, זוכי פרס נובל ואפילו... לא נגלה לכם הכל, תעשו סיבוב!**
    זימון חדר ישיבות:\n
    •	ביומן באאוטלוק הקליקו על Location ולאחר מכן מיינו לפי IL. תוכלו לראות את רשימת החדרים בכל קומה ואם תסמנו אותם 
    תוכלו לראות אם הם פנויים או תפוסים – כפי שרואים זמינות של אדם אחר ביומן אאוטלוק.
    לאחר שתבחרו את החדר המתאים עבורכם, הוסיפו אותו לרשימת המזומנים לפגישה ותקבלו במייל אישור על זימון החדר.\n
    •	ניתן לזמן חדרי ישיבות בכל קומה, שימו לב כי ליד כל חדר מצויין מספר האנשים המקסימלי לו הוא מיועד, לנוחיותכם.\n
    **אנו עובדים ב Open Space. כל עמדת עבודה מצוידת במה שצריך כדי לעבוד בנוחות ויעילות: מסכים איכותיים, שולחן מתכוונן עד לעמידה וכיסא ארגונומי שנבחר על-ידי העובדים עצמם.** בכל קומה, באגף המזרחי, יש גם הליכונים אליהם אפשר לחבר את הלפטופ ולעבוד תוך כדי תנועה 
בסך הכל מעל 600 עמדות עבודה שמחכות רק לכם! \n
זימון עמדות עבודה:\n
•	כל עובד מוגדר כחלק מ"שכונה" מסויימת, זו ה"שכונה" של היחידה -
 תחנות עבודה ייעודיות הלוקחות בחשבון את מספר העובדים בכל יחידה. 
 רק עובדי היחידה יכולים להזמין תחנת עבודה ב"שכונה" שלהם. בנוסף, ישנן  עמדות כלליות בקומות, הפתוחות לכולם.\n
•	על מנת לברר לאיזו "שכונה" אתם שייכים - פנו למנהל.ת שלכם. במקרה שאינכם משויכים עדיין לשכונה (גם זה יכול לקרות מידי פעם...) 
- יש לפנות ל- [Facilities](mailto:yossibar24@gmail.com)\n•	עמדות העבודה הארגונומיות שלכם כוללות שולחן עבודה מתכוונן, כיסא אורטופדי
 ו- 2 מסכים מתכווננים וכן מצלמת וידאו לשיחות. 
 בנוסף, לכל עובד יש מקלדת אישית, עכבר ואוזניות מפחיתות רעש – זה ישפר לכם את חווית העבודה. הדום לרגליים ניתן לבקש משירותי הקמפוס, יש לפנות ל- Facilities\n
•	ניתן להזמין עמדות עבודה עד שבועיים מראש.\n
•	רוצים להזמין עמדת עבודה? השתמשו באפליקציית ה- [Office Space](https://nice.officespacesoftware.com/visual-directory/floors/80). 
[הנחיות מפורטות על כניסה ושימוש ב-Office Space](#pdf-attache2)
    `,
  },
  {
    id: 11,
    uniqueId: 'working_in_space_11',
    title: 'בחרתם להדפיס?',
    content: `אצלנו שומרים על סביבה ירוקה.  
    במקרה שהחלטתם להדפיס, דאגנו למדפסות מתקדמות המספקות חוויית משתמש נעימה, מהירה וכמובן, מאובטחת!
    תוכלו למצוא אותן בקומות 2, 3, 4, 6\n
    כדי לשלוח מסמך להדפסה, יש לבצע התקנה פשוטה, [לחצו כאן להוראות](#pdf-attache3).\n
    בכל שאלה ניתן לפנות לצוות התשתיות: [AskFacilitiesIL@nice.com](mailto:AskFacilitiesIL@nice.com),\n
    או לצוותIT  - באמצעות פתיחת קריאה ע"י הלינק המצורף:  [https://nicensc.service-now.com/nsc](https://nicensc.service-now.com/nsc).
    `,
  },
]

export const health1 = [
  {
    id: 1,
    uniqueId: 'health_1',
    title: 'בריאות ויופי',
    content: `  בחדר הטיפולים שלנו תוכלו ליהנות משירותי לק-ג'ל וביוטי לאורך השבוע.
    **בנוסף, תוכלו לעבור בדיקות תקופתיות של רופאי עור, כירורגית שד ובדיקות אופטומטריה.**\n
        פגישות תקופתיות לבדיקת בריאות.\n
        התאמת ורכישה של אופטומטריה ומשקפיים במחירים מוזלים.\n
        מגוון טיפולי יופי מאנשי מקצוע מורשים.\n
        לחצו כדי להירשם [לטיפולי יופי ובריאות](https://ageutmky.web.arboxapp.com/group?whitelabel=Arbox&lang=he&referrer=SITE&location=14078&allLocations=false)
        `,
  },
  {
    id: 2,
    uniqueId: 'health_2',
    title: 'חדר כושר',
    content: `במתחם התעשייה פארק רעננה חדר כושר חדיש עם מכשור מתקדם.\n
    אנחנו מעודדים את עובדי נייס להתאמן ולהנות מסטודיו **עם מגוון עשיר של חוגים: יוגה, פילאטיס, HIT ועוד.** כמו כן, תמצאו במתחם אזור אימוני Outdoor ואזור ייעודי לשיעורי הסטודיו כמו גם מלתחות ומקלחות מאובזרים ככה שתסיימו את האימון רעננים. \n
    חדר הכושר מנוהל על-ידי מנהלת הפארק, **ופתוח לעובדי NICE בעלות מסובסדת.** העלות מכוסה במלואה על-ידי NICE מלבד המס ברוטו (~40 ₪ - נכון להיום, החברה רשאית לשנות סכום זה מעת לעת בהתאם למדיניות).\n
    רוצים להתאמן? יש לחתום על הצהרת בריאות ולעבור הדרכה על-ידי צוות המאמנים. \n
    לרישום לחדר הכושר, הרשמה להדרכה וחתימה על הצהרת בריאות לחצו [כאן](https://m.fizikal.co.il/website/JoinNow.aspx?COBR=ykezEFy%2BowukXrqp8C7Enru0WAk7ZDMJD4PNnAt8hJY=&byContractTypeId=8000#/join_now).\n
    **במעמד ההדרכה והרישום הציגו את כרטיס העובד.** \n
    ניתן להוריד את אפליקציית חדר הכושר למכשיר האייפון או האנדרואיד שברשותכם. \n\n
    לשאלות בנוגע לחדר הכושר: [HitechGym@arielgroup.co.il](mailto:HitechGym@arielgroup.co.il)\nמשאבי אנוש:  [AskHR-IL@nice.com](mailto:AskHR-IL@nice.com)\n שירותים ותשתיות:  [AskFacilitiesIL@nice.com](mailto:AskFacilitiesIL@nice.com)\n
    `,
  },
  {
    id: 3,
    uniqueId: 'health_3',
    title: 'מקלחות',
    content: `מקלחות מסודרות ונקיות ממוקמות בבניין NICE 2 קומה 1. מנויי חדר הכושר יכולים להשתמש גם במקלחות בחדר הכושר.\n
    **מידי שנה מתקיים חודש הבריאות ב- NICE**, המוקדש כולו לגוף ולנפש. במהלך חודש זה מתקיימות הרצאות בנושא, שיעורי כושר מגוונים, סדנאות שונות, קורסי עזרה ראשונה ועוד. 
    `,
  },
]

export const food1 = [
  {
    id: 1,
    uniqueId: 'food_1',
    title: 'כרטיס Cibus ומשלוחי מזון',
    content: `
    את כרטיס ה- Cibus והחשבון המשויך אליו, תקבלו מיד עם הצטרפותכם ל- NICE- תוכלו להזמין אוכל ולבצע רכישות בסופרמרקט. כדי לראות את כל מה שהכרטיס מאפשר, היכנסו ל
    [אתר Cibus. ניתן להשתמש באתר במחשב וכן להוריד כאפליקציה בטלפון.](https://consumers.pluxee.co.il/login) \n
    **התקציב החודשי לעובדים במשרה מלאה הוא 850 ₪; התקציב החודשי לסטודנטים הוא 450 ₪. סכום זה מתעדכן מעת לעת בהתאם למדיניות החברה. מס ברוטו בגין הטבה זו ינוכה באמצעות השכר.**\n
    התקציב הינו לחודש קלנדרי שלם, ללא מגבלות יומיות; לא ניתן להעביר יתרת תקציב בסוף החודש.\n
    בהזמנת אוכל למשרד NICE, הזינו את הכתובת: רחוב זרחין 13, רעננה. \n
    כשהמשלוח יגיע תקבלו הודעה. בואו לאסוף את ההזמנה מהחדר המיועד, מאחורי דלפק הקבלה בלובי. \n
    חשבון Cibus יכול לשמש לתשלום עבור משלוחי מזון דרך וולט. לשם כך יש להוסיף את חשבון ה- Cibus לאפליקציית Wolt כאמצעי תשלום: פרופיל>אמצעי תשלום>הוסף חדש. \n\n
    
    [לחצו כאן להורדת מצגת עם פרטים נוספים על השימוש ב- Cibus](#pdf-attache4)
`,
  },
  {
    id: 2,
    uniqueId: 'food_2',
    title: 'אירועים ואוכל מותאם לכולם',
    content: `
    אנחנו ארגון בעל תו תקן רשמי של {logo} ובכל אירוע ופעילות תוכלו למצוא מגוון אופציות לטבעוניים, כמו גם במשרד.\n
    כארגון מכיל תגלו שבכל אירוע יש אפשרויות מותאמות גם לכשרות בד"צ, לנמנעים מגלוטן וכאמור, לטבעונים. לא מצאתם? גשו לנציגי HR ותקבלו מענה.
`,
  },
  {
    id: 3,
    uniqueId: 'food_3',
    title: 'שמירה על הסביבה במשרד',
    content: `
    כחברה, אנו לוקחים חלק פעיל במאמץ לשמירה על הסביבה. בכל הקומות וכן במתחם האוכל תוכלו למצוא מגוון עשיר של כלים "של בית", בחרו את מה שנעים ומתאים לכם ביותר לאוכל ולשתייה ועזרו לנו להמשיך לצמצם את השימוש בחד פעמי למינימום! לנוחיותכם מדיחי כלים בכל קומה.`,
  },
  {
    id: 4,
    uniqueId: 'food_4',
    title: 'הטבה במסעדת אגוסטין',
    content: `
  הטבה במסעדת אגוסטין מבית קפה נואר הצמודה למשרד.`,
  },
  {
    id: 5,
    uniqueId: 'food_5',
    title: 'הטבה במסעדת "בקרו"',
    content: ``,
  },
  {
    id: 6,
    uniqueId: 'food_6',
    title: 'הטבה במסעדת "poke van"',
    content: ``,
  },
]

export const allAround1 = [
  {
    id: 1,
    uniqueId: 'allAround_1',
    title: 'עבודה היברידית, אצלנו זה NICE FLEX',
    content: `
    כשאנחנו נפגשים פנים-אל-פנים, אנחנו בשיא שלנו! 
    חדשנות, שיתוף פעולה, סיעור מוחות – 
    הכל הרבה יותר יצירתי ומשמעותי.\n
    **מודל ה- NICE FLEX, מתבסס על 2 ימי עבודה מהמשרד ו-3 ימי עבודה מרחוק, בכל שבוע.**\n
    איך זה עובד? כל חברי הצוות מגיעים לשני ימי משרד בשבוע. אילו ימים? הצוות והמנהל מחליטים ביחד! אנחנו גמישים, אפשר לשנות את הימים בהחלטה משותפת.\n\n
    •	לצוות יש ממשקים ספציפיים? תאמו את ימי המשרד של הצוות עם ימי המשרד של הממשקים כך תוכלו להנות מהיתרונות שבאינטראקציה.\n
    •	התארגנתם ויצאתם למשרד, נצלו את היום - ימי המשרד הם ימי עבודה מלאים. \n
    •	ימי המשרד הם הזדמנות מצוינת לפגישות צוות, פגישות אחד על אחד, סשנים של שיתוף פעולה וכדומה. \n
    •	במקרה של נסיבות חד פעמיות המונעות מעובד להגיע ביום הקבוע של הצוות, על העובד להגיע למשרד ביום משרד חלופי באותו שבוע, כאשר הממשקים שלו נוכחים, ובאישור המנהל שלו. \n
    •	"נסיבות חד פעמיות" אינן כוללות ימי חופשה ומחלה. \n
    •	ניתן לבקש עד 3 שבועות עבודה מרחוק בשנה קלנדרית, בהתאם לנסיבות אישיות או רפואיות. האישור ינתן על ידי הסמנכ"ל ומנהל.ת משאבי האנוש היחידתיים.
    `,
  },
  {
    id: 2,
    uniqueId: 'allAround_2',
    title: 'סביבת עבודה במכשירים ניידים',
    content: `
    לפעמים הכי נוח להתחבר מהנייד או מהטאבלט. אנחנו משתמשים ב - Microsoft Intune, אפליקציית ניהול התקנים ניידים שהופכת את סביבת העבודה של NICE לנגישה הרבה יותר עבורכם, גם בנייד.\n
    •	אם יש לכם גישה לנתוני NICE (כמו Outlook  או  Teams) במכשיר הנייד, המכשיר שלכם כבר 'רשום', ותוכלו להנות מגישה ליישומים ארגוניים נוספים של NICE בנייד, תוך הגנה על נתונים ארגוניים ואישיים.
    `,
  },
  {
    id: 3,
    uniqueId: 'allAround_3',
    title: `אין קאצ'! – יש חניה!`,
    content: `
    •	רשמו את רכבכם מראש, כדי שתוכלו להיכנס לחניון [IL-Car-Parking](https://niceonline.sharepoint.com/sites/NWBWork/SitePages/IL-Car-Parking.aspx/). תוכלו לרשום שני רכבים במידה ואינכם מגיעים עם רכב קבוע. \n
    •	יש להחנות אך ורק באזורים המיועדים לעובדי NICE. \n
    •	חלק מהחניונים מיועדים לרכבים גבוהים. שימו לב לשילוט והחנו במקום הנכון, כך לכל העובדים תהיה חניה.\n
    •	חניה בחניון 3- היא במקומות חניה רבי קומות (מכפילי חניה). השימוש במתקן החניה רב הקומות מותנה בהכשרה ודורש מפתח. להדרכה יש להירשם  ל[הדרכה לשימוש במכפילי חניה](https://niceonline.sharepoint.com/sites/NWBWork/SitePages/IL-NICE1-Machpilim-Details.aspx)

    `,
  },
  {
    id: 4,
    uniqueId: 'allAround_4',
    title: `אורחים`,
    content: `•	אנחנו אוהבים אורחים, אבל רק אם הם עוברים בלובי ונרשמים בדלפק הקבלה. \n
    •	כל האורחים, כולל ילדים, חייבים להיות מלווים ב-NICEr בזמן שהם מבקרים במשרדי החברה. \n
    •	חניית אורחים: רחוב זרחין 20, חניה היקפית סביב המבנים שמעבר לרחוב. כל אורח צריך להכנס דרך הלובי ורישום בקבלה. על עובד נייס להגיע ללוות את האורח פנימה. 
    `,
  },
]

export const pension1 = [
  {
    id: 1,
    uniqueId: 'pension_1',
    title: `פנסיה ואבדן כושר עבודה`,
    content: `    •	כעובדי NICE, אתם זכאים לכיסוי פנסיוני מהיום הראשון לעבודתכם.\n
    •	לבחירתכם אחד משני מנהלי הסדר  תמורה או מבטח סיימון.\n
    אם טרם בחרתם מנהל הסדר, צרו קשר עם מחלקת שכר. באפשרותכם גם לבחור לעבוד עם סוכן פרטי - 
    לצורך כך הסוכן שבחרתם נדרש להעביר, הנחיות בטופס ייעודי למחלקת השכר. \n
    גם אם בחרתם לעבוד עם סוכן פנסיוני פרטי, 
    אנו ממליצים לקבוע פגישה לא מחייבת עם אחד ממנהלי ההסדר תמורה או מבטח סיימון על מנת לשמוע עוד חוות דעת והכוונה לפני החלטה סופית או התאמת התיק ע"י הסוכן הפרטי.\n\n
    **ל- NICE  הסכמים עם  חברות ביטוח גדולות להטבות משמעותיות בעלויות התפעול של קרן הפנסיה ועל תעריפי אובדן כושר עבודה.**\n
    •	בהתאם לבחירתכם, סוכן מטעם מנהל ההסדר הפנסיוני ייצור איתכם קשר וייקבע מפגש למתן פרטים והסברים.


    `,
  },
  {
    id: 2,
    uniqueId: 'pension_2',
    title: `ביטוח בריאות`,
    content: `  
    •	יש לנו ביטוח בריאות קבוצתי ייחודי לעובדי NICE המסופק באמצעות חברת הביטוח מנורה מבטחים ומנוהל ע”י מדנס סוכנות לביטוח.\n
    • ביטוח בריאות קבוצתי לעובדי NICE כמשלים שב”ן/ביטוח מורחב (מהשקל הראשון)  יסייע לך למקסם את ההחזר עבור הוצאות רפואיות.\n
    •	רוצים להצטרף? עליכם לאשר הצטרפותכם על מנת לקבל מימון מלא לתוכנית הביטוח לעובדי NICE ובני משפחה  ולאשר ניכוי תעריפי צירוף בני משפחה/שווי מס בגין ההטבה ע”פ תנאי הפוליסה.\n
    יש לכם מקרה ביטוח? [לחצו להגשת תביעה](https://www.menoramivt.co.il/product/health-claim-list)\n פרטים נוספים אודות ביטוח הבריאות תוכלו למצוא [כאן](https://niceonline.sharepoint.com/sites/NWBNICE4ME/SitePages/IL-Benefit-Health-Insurance.aspx)\n
    מדנס – פרטי התקשרות:
    `,
  },
  {
    id: 3,
    uniqueId: 'pension_3',
    title: 'קרן השתלמות',
    content: `    •	ל- NICE  הסכמים עם מגוון רחב של חברות השקעה בתנאים מיטיבים.\n
    •	תוכלו להחליט האם ברצונכם להפריש לקרן ההשתלמות דרך אחת מסוכנויות התפעול או באופן ישיר מול חברת ההשקעות. \n
    •	NICE מפקידה עבורכם עד לתקרת השכר הפטורה ממס.\n
    •	ההפקדות נעשות הן ע"י NICE (7.5%) והן ע"י העובד (2.5%).
    `,
  },
  {
    id: 4,
    uniqueId: 'pension_4',
    title: 'ימי הבראה',
    content: `    •	NICE  משלמת ימי הבראה ע"פ חוק.\n
    •	 שווי יום הבראה אחד הינו 418 ₪ נכון ליולי 2024.\n
    •	 וותק העובד בחברה קודמת אינו נוסף לצורך חישוב ימי ההבראה.
    `,
  },
  {
    id: 5,
    uniqueId: 'pension_5',
    title: 'ימי חופשה ומחלה',
    content: `    ימי חופשה:\n
    •	נצלו  את ימי החופשה הצבורים שלכם בתיאום עם מנהלכם ובאישור מראש.\n
    •	פעם בשנה עליכם לצאת לחופשה של מינימום 5 ימי עבודה רצופים.\n
    •	ייתכנו ימי חופש, חלקיים או מלאים, בהנחיית החברה.\n\n
    צבירת ימי חופשה:\n
    •	ניתן לצבור משנה לשנה ימי חופשה שלא נוצלו עד לכמות של מכסה שנתית אחת.\n
    •	בסוף כל שנה קלנדרית ימי חופשה שנצברו מעל למכסה השנתית יימחקו למעט במקרים אישיים חריגים ובאישור משאבי אנוש.\n\n
  	ימי חופשה מיוחדים הממומנים ע"י NICE: \n
    •	לידת ילד.ה – 3 ימים\n
    •	בר/בת מצווה ילד.ה – יום אחד\n
    •	חתונת עובד - 3 ימים\n
    •	חתונת ילד.ה - יום אחד\n
    •	אבלות - שבוע קלנדרי\n\n
    ימי מחלה:\n
    •NICE מאפשרת ניצול של עד 2 ימי מחלה בחודש ע"פי הצהרה (ללא אישור רפואי).\n
    •	מהיום השלישי (כולל) ומעלה – תידרשו לצרף לדיווח המחלה בחילן אישור מחלה מרופא  או קופת חולים.\n
    •	צבירת ימי המחלה ע"פי חוק- עד 90 ימים.\n
    NICE • אינה מגבילה את השימוש בימי מחלה עבור מחלת ילד/הורה וכו' ומאפשרת שימוש במכסת ימי המחלה לכל סוגי ימי המחלה.
    `,
  },
  {
    id: 6,
    uniqueId: 'pension_6',
    title: 'מידע שימושי',
    content: `  
    •	חבר מביא חבר
    החברים שלכם יכולים להיות הרבה יותר קרובים ולזכות אתכם בבונוס!\n
    •	רוצים להפנות מישהו/י למשרה פתוחה? היכנסו לקישור הזה [Referrals](https://learn.greenhouse.io/submit-referrals?next=%2Fsubmit-referrals%2F862509) \n
    •	לרשימת המשרות הפתוחות באתר החברה לחצו כאן: [משרות פתוחות](https://niceonline.sharepoint.com/sites/NWBGrow/SitePages/Careers.aspx?xsdata=MDV8MDF8fDY2Yzc4Y2IxODkxMjQ0Y2JhMjQzMDhkYWViZmI1ZTQ4fDcxMjNkYWJkMGU4NzRkYTk5Y2I5YjdlYzgyMDExYWFkfDB8MHw2MzgwODE3NjIwNzc0ODM1ODd8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaVYybHVNeklpTENKQlRpSTZJazkwYUdWeUlpd2lWMVFpT2pFeGZRPT18MXxNVFkzTWpVM09UUXdOelV3T1RzeE5qY3lOVGM1TkRBM05UQTVPekU1T2poa01tUmhZakUxTFRoa09Ea3RORFpqTWkxaFpHVTVMVFV5TlRFeFl6TmtPV0ppTWw5aU5HWmlOVGRtTVMwMk1EazBMVFE1WmpZdE9HUTRaaTB4TVRNd05EWm1aRGt3TVdGQWRXNXhMbWRpYkM1emNHRmpaWE09fGRiNWNhZGM5NDNhODQzZDdhMjQzMDhkYWViZmI1ZTQ4fGYzZGYwMDhlMmM1YTRiODY5NWM5MDAzNmZlODYzNWU4&sdata=eCs3SmxiNHQ4Rm1rR3RWeDJJWS9JcnAvdVBhalUrSUZkUExZbGg2dUdGWT0%3D&ovuser=7123dabd-0e87-4da9-9cb9-b7ec82011aad%2cYaara.EldarKaplan%40nice.com&OR=Teams-HL&CT=1672580308579&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyNy8yMjExMzAwNDEwMCIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D)
    •	במידה ומישהו שהפניתם יתקבל לעבוד בנייס, הרווחתם פעמיים! גם לאנצ' באדי חדשים וגם בונוס כספי!
    •	וזה לא הכל, מדי כמה זמן יש לנו מבצעי "חבר-מביא-חבר" ייעודים נושאי פרסים מיוחדים ושווים במיוחד!
    •	לפרטים נוספים על תוכנית "חבר-מביא-חבר" [לחצו כאן](https://niceonline.sharepoint.com/sites/NWBGrow/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FNWBGrow%2FShared%20Documents%2FReferral%20Policy%20%2D%20July%202024%2Epdf&parent=%2Fsites%2FNWBGrow%2FShared%20Documents)
    
    `,
  },
  {
    id: 7,
    uniqueId: 'pension_7',
    title: 'חברות בהיי-טק זון',
    content: ` 
    •	כעובדי NICE הנכם רשומים אוטומטית למועדון הצרכנות HTZ, המציע הנחות על מוצרים ושירותים רבים. \n
    •	ניתן להצטרף לתוכנית כרטיס האשראי Pro2 ללא עמלות, ולהנות מהנחות טובות עוד יותר. \n
    •	בקרו באתר HTZ כדי להירשם באמצעות חשבון הדוא"ל שלכם ב-NICE. \n
    אתר [HTZ](https://www.htzone.co.il/)
    `,
  },
  {
    id: 8,
    uniqueId: 'pension_8',
    title: 'תוכנית ליסינג לרכב',
    content: ` 
    • NICE מציעה תוכנית ליסינג רכב לכל חברי NICE העובדים במשרה מלאה. \n
        •	לפרטים נוספים עיינו במסמך [מדיניות רכב](https://niceonline.sharepoint.com/sites/NWBWork/Real%20Estate%20and%20Facilities/Forms/AllItems.aspx?id=%2Fsites%2FNWBWork%2FReal%20Estate%20and%20Facilities%2FIL%2FCar%20Site%2Fleasing%20program%2Fcar%20leasing%20procudure%20120223%2Epdf&parent=%2Fsites%2FNWBWork%2FReal%20Estate%20and%20Facilities%2FIL%2FCar%20Site%2Fleasing%20program) או צרו קשר עם מנהל צי הרכב של NICE  \n
    [NICE Car Fleet Manager](mailto:gal.gemer@nice.com)
    `,
  },
  {
    id: 9,
    uniqueId: 'pension_9',
    title: 'תוכנית טלפון סלולרי ותקשורת',
    content: ` 
    •	 עובדים בתפקידים הדורשים תקשורת עם לקוחות החברה או ספקי שירות, וכן עובדים בתפקידי תמיכה או מכירה זכאים להצטרף לתוכנית הטלפונים הסלולריים. פתיחת הקריאה נעשית אוטומטית עבור עובדים זכאיים ומטופלת על ידי מחלקת טלפוניה שתחת IT.
    •	כעובדי נייס, אתם ובני משפחותיכם, זכאים לתוכניות סלולר, טלויזיה ואינטרנט אטרקטיביות בחברת, [פרטנר Partner](https://www.partner.co.il/u/partnerfamily/nice35)`,
  },
  {
    id: 10,
    uniqueId: 'pension_10',
    title: 'עדכון מידע אישי',
    content: ` 
    •	לעדכון פרטים אישיים, גשו ל-Oracle באמצעות קישור זה [עדכון פרטים אישיים](https://nicensc.service-now.com/esc?id=sc_cat_item&sys_id=4d6cd1981b3cd010bcbe2f06bd4bcb90)
   •	לפני החיבור, ודאו שאתם:
   1. גולשים ב-EDGE\n
   2. מחוברים ל-VPN ונכנסים עם שם היוזר שלכם ב- NICE\n
   3. הזינו את שם המשתמש והסיסמה של המחשב שלכם כדי לגשת ל-Oracle
    `,
  },
  {
    id: 11,
    uniqueId: 'pension_11',
    title: 'נוכחות ותלוש שכר',
    content: ` 
    •	השתמשו ב- [HILANET](https://nice.net.hilan.co.il/login?lang=en)  כדי להזין ולעדכן את פרטי הנוכחות והחופשות שלכם ולגשת לתלוש השכר.\n\n
    •	שימו לב - המערכת פתוחה לדיווח נוכחות עד ה-10 לחודש העוקב.\n
    •	ימים ללא נוכחות מדווחת שאושרה על ידי המנהל יירשמו כימי חופשה, וינוכו ממכסת החופשות שלכם.\n
    •	היכנסו להדרכה האינטראקטיבית על המערכת, כדי להכיר את המערכת ואת אופן התפעול שלה באתר ב- [HILANET](https://nice.net.hilan.co.il/login?lang=en). \n\n
    •	לתמיכה ב-Payroll צרו קשר עם [Payroll_IL@nice.com](mailto:Payroll_IL@nice.com).
    `,
  },
  {
    id: 12,
    uniqueId: 'pension_12',
    title: 'אנחנו NICE בשבילכם, בכל נושא ',
    content: ` 
    יש לכם שאילתות או בקשות בתחום ה-IT, ניהול ההזמנות, המתקנים, InfoSec ו-HR
    לחצו על הקישור [Employee Service Center](https://nicensc.service-now.com/now/nav/ui/classic/params/target/home_splash.do%3Fsysparm_direct%3Dtrue)\n
    •	שכר -  [Payroll_IL@nice.com](mailto:Payroll_IL@nice.com)\n
    •	עמדת קבלה ב NICE ישראל -  09-7753777
    `,
  },
  {
    id: 13,
    uniqueId: 'pension_13',
    title: `תמיכה נפשית`,
    content: `
    •	חברת "אשחר" מספקת לנו שירותי תמיכה וטיפול מקוונים - שיחות התייעצות, שיחות הפגה ותמיכה אישית לאורך כל שעות היממה. לפעמים, אפילו שיחה קצרה יכולה להקל עלינו בזמנים קשים.\n\n
    מוזמנים לפנות ישירות ובדיסקרטיות לאנשי המקצוע בחברת "אשחר", 24/7 במספרים הבאים:\n
    יעל – 054-8056876\n
    מיקה – 050-7485019\n
    מיכל – 050-6530528
`,
  },
  {
    id: 14,
    uniqueId: 'pension_14',
    title: `הריון, הורות טרייה, חיתולים ומה שביניהם ?`,
    content: `
    אתם הורים מצפים? נולד לכם ילד? יש הרבה שכדאי לדעת, החל מתקופת ההיריון, ביטוחי בריאות ,ימי חופשה וכלה בבחירת המתנה המגיעה לכם.\n
    על לידת ילד/ה תקבלו – 3 ימי חופשה על חשבון NICE\n
    כמו כן תוכלו לבחור מתנת לידה לטעמכם.\n\n
    •	הזכאות לסיבוס Cibus  אינה ממשיכה במהלך חל"ד או חל"ת.\n
    חברות במועדון הנחשק!\n
    **מועדון NICE Tinies המיועד לתינוקות שנולדו לעובדי ועובדות החברה, ובו אנו מקיימים מפגש הורים-תינוקות,** שבמהלכם דור העתיד זוכה להנות יחד עם ההורים במגוון פעילויות, נשנושים, צילומים והפתעות. הזמנות נשלחות ישירות להורים הרלוונטים אחת לרבעון.
    `,
  },
  {
    id: 15,
    uniqueId: 'pension_15',
    title: `הטבה בחנות כפר השעשועים`,
    content: ``,
  },
]
